
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide/save-tabs",
      function () {
        return require("private-next-pages/guide/save-tabs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide/save-tabs"])
      });
    }
  